import 'moment/locale/fr';
import 'moment/locale/fr-ca';
import 'moment/locale/zh-cn';
import 'moment/locale/it';
import 'moment/locale/ru';
import 'moment/locale/de';
import 'moment/locale/es';
import 'moment/locale/pt-br';
import 'moment/locale/ja';
import 'moment/locale/pl';